import { render, staticRenderFns } from "./AllCompanyDataUpdateSubmissions.vue?vue&type=template&id=28b88456&scoped=true&"
import script from "./AllCompanyDataUpdateSubmissions.vue?vue&type=script&lang=js&"
export * from "./AllCompanyDataUpdateSubmissions.vue?vue&type=script&lang=js&"
import style0 from "./AllCompanyDataUpdateSubmissions.vue?vue&type=style&index=0&id=28b88456&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b88456",
  null
  
)

export default component.exports